export default __webpack_public_path__ + "assets/images/d4170c01fd4dccd797735e5ac03dd921.png";